import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { SectionLoader } from "../../shared/SectionLoader";

function LoginPage() {
  const { logIn, idToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (idToken) {
      navigate("/");
    } else {
      logIn();
    }
  }, [idToken, logIn, navigate]);

  return <SectionLoader message="Redirecting to login page, please wait..." />;
}

export default LoginPage;
